<template>
  <card>
    <h4 slot="header" class="card-title">Espace Utilisateur</h4>
    <article class="uk-comment uk-visible-toggle" tabindex="-1">
      <header class="uk-comment-header uk-position-relative">
          <div class="uk-grid-medium uk-flex-middle" uk-grid>
              <div class="uk-width-auto">
                  <img class="uk-comment-avatar" src="/img/livreur.jpg" width="80" height="80" alt="">
              </div>
              <div class="uk-width-expand">
                  <h4 class="uk-comment-title uk-margin-remove">{{ user.name }}</h4>
                  <p class="uk-comment-meta uk-margin-remove-top">{{role}}</p>
              </div>
          </div>
          <div class="uk-position-top-right uk-position-small uk-hidden-hover">
            <router-link :to="{path: '/Client_edit/' + user.id }" v-bind:tooltip="user.id"  class="btn btn-danger mr-2 uk-box-shadow-large">
                <span class="" style="color: green red" uk-icon="icon:pencil; ratio: 1"></span>
            </router-link>
          </div>
      </header>
    </article>
  </card>
</template>
<script>
  import Card from 'src/components/Cards/Card.vue'
  import "firebase/auth";
  import { db } from '../../main';
  export default {
    components: {
      Card
    },
    data () {
      return {
        user: {},
        getRole :0,
        role:""
      }
    },
    created () {
      this.user =  this.$store.getters.user.data;
      if(this.user == null){
        this.$router.push({ path: "/login"});
      }
      this.getRole =  this.$store.getters.user.data.role;
      if(this.getRole == 0){
        this.role = 'Client'
      } else if(this.getRole == 1){
        this.role = 'Livreur'
      } else if(this.getRole == 2){
        this.role = 'Commercial'
      } else if(this.getRole == 3){
        this.role = 'Superviseur'
      } else if(this.getRole == 4){
        this.role = 'Logisticien'
      } else if(this.getRole == 5){
        this.role = 'Administrateur'
      }else{
        return this.role = 'Erreur Système'
      }
    
    },

    methods: {
      
    }
  }

</script>
<style>

</style>
